import {calculatePrice, safeRedirect} from "../../tools/helpers";
import Button from "../Button";
import {useContext, useState} from "react";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import ListItem from "../ListItem";
import PolicyModal from "../modals/PolicyModal";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import {useNavigate} from "react-router-dom";

const CreatePayment = () => {
    const serviceContext = useContext(AuthenticationServiceContext)
    const [loading, setLoading] = useState(false);
    const [acceptPolicy, setAcceptPolicy] = useState(false);
    const navigate=useNavigate();
    const handleAcceptPolicy = (e) => {

        setAcceptPolicy(e.target.checked)
    }
    const handlePolicyModal = () => {
        Reoverlay.showModal(PolicyModal)
    }
    const handleCreatePayment = () => {
        setLoading(true)
        const data = {
            "pid": serviceContext.pid,

        }
        Api.post(REQUEST_URLS.AUTHENTICATION.CREATE_PAYMENT, data, {
            headers: {
                "Authorization": `Bearer ${serviceContext.token}`
            }
        }).then(response => {

            const {hasError, status, message, data} = response;

            if (!hasError) {
                safeRedirect(data.pay_url,()=>{
                    Reoverlay.showModal(ErrorModal,{
                        title:'خطا',
                        message:'لینک معتبر نمی باشد.',
                        showCancelButton: true,
                        cancelButtonText:'بستن',
                        onCancel:()=>{
                            Reoverlay.hideModal();
                            setLoading(false);
                            navigate('/404')
                        }
                    })
                })
            } else {
                setLoading(false)
                serviceContext.handleError({
                    message,
                    status,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'بستن',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                Reoverlay.hideModal();
                            }
                        })
                    }
                })

            }

        }).catch(e => {
            setLoading(false)
            console.log(e)

        })


    }

    return <div
        className="bg-white mx-auto w-11/12 md:w-6/12 lg:w-4/12  flex flex-col mt-10 items-center justify-center p-5 rounded-lg">
        <div className="w-full mb-3 p-3 rounded-lg  border-b  flex justify-center items-center w-full flex-col">
            <h1 className="text-xl mb-2 text-green-500 font-bold ">پرداخت</h1>
            <p className=" text-sm border-gray-200">برای ادامه ابتدا باید پرداخت را انجام دهید.</p>
        </div>
        <div className="w-full justify-center items-center flex-col">
            <ListItem isPrice={true} title={'مبلغ'} value={+(serviceContext?.process.payment?.info?.init_amount) / 10}
                       priceUnit={'تومان'}/>
            <ListItem title={'مالیات'} value={10} isPercent={true}/>
            <ListItem isGreen={true} title={'مبلغ پرداختی'}
                       value={calculatePrice(+(serviceContext?.process.payment?.info?.init_amount))} isPrice={true}
                       priceUnit={'تومان'}/>
            <div className="flex justify-between mt-2  py-3 border-t">
                <div className="flex justify-start items-center ">
                    <span className="text-xs">قوانین را می‌پذیرم</span>
                    <input className="mx-2" onChange={handleAcceptPolicy} type="checkbox" checked={acceptPolicy}/>
                </div>
                <span onClick={handlePolicyModal} className="text-blue-400 text-xs underline ">مطالعه قوانین</span>
            </div>
            <Button loading={loading} disabled={!acceptPolicy} rounded="rounded-lg" theme="green" className="w-full"
                    onClick={handleCreatePayment}>پرداخت</Button>
        </div>

    </div>
}
export default CreatePayment;